import { useEffect, useState } from "react";
import { InputContainer } from "../../../../../../common/components/form/form.module";

export const RateCardVehicleCategory = ({ taxonomy, distances, vehicleCategories, handleFormItemChange, vehicleBodyTypes, vehicleList, removeTaxonomy, addTaxonomyRow }: any) => {



    return (
        <>
            {/* Vehicle Info Table */}

            <table className="w-full border mb-4">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="border p-2 w-40">Category Vehicle</th>
                        <th className="border p-2 w-28">Vehicle BodyType</th>
                        <th className="border p-2 w-48">Mapped Vehicles </th>
                        <th className="border p-2 w-16">Distance Unit</th>
                        <th className="border p-2 w-20">Minimum Distance</th>
                        <th className="border p-2 w-20">Maximum Distance</th>
                        <th className="border p-2 w-20">Distance Increment</th>
                        <th className="border p-2 w-20">Distance Increment Charge</th>
                        <th className="border p-2 w-10">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {taxonomy?.map((v, idx) => (
                        <tr key={idx}>
                            <td className="border p-1">

                                <InputContainer

                                    labelField="LogisticsVehicleCategoryName"
                                    list={vehicleCategories}
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "LogisticsCategoryVehicleId", e.target.value)
                                    }}
                                    optionName='Choose vehicle Category'
                                    type="select"
                                    value={v.LogisticsCategoryVehicleId}
                                    valueField="Id"
                                />


                            </td>
                            <td className="border p-1">
                                <InputContainer

                                    labelField="Text"
                                    list={vehicleBodyTypes}
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "VehicleBodyTypeId", e.target.value)
                                    }}
                                    optionName='Choose vehicle bodyType'
                                    type="select"
                                    value={v.VehicleBodyTypeId}
                                    valueField="Value"
                                />

                            </td>
                            <td className="border p-1">

                                <InputContainer
                                    className=' pl-4 pr-7  border w-full border-black/50 text-xs rounded py-2 px-1 bg-gray-50 '
                                    labelField="VehicleName"
                                    list={vehicleList.filter(
                                        (item: any) => item.VehicleBodyTypeId == v?.VehicleBodyTypeId
                                    )}
                                    onValueChange={(newValue: any) => {
                                        const vehicleData: any = newValue.map((option: any) => option?.value || '')
                                        handleFormItemChange(idx, "VehicleIds", vehicleData)

                                    }}
                                    type="multiselect"
                                    valueField="Id"
                                    value={v?.VehicleIds}
                                />

                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    labelField="SystemKeyword"
                                    list={distances}
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "DistanceUnitId", e.target.value)
                                    }}
                                    optionName='Choose DistanceUnitId'
                                    type="select"
                                    value={v.DistanceUnitId}
                                    valueField="Id"
                                />




                            </td>

                            <td className="border p-1">

                                <InputContainer

                                    name="MinimumDistance"
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "MinimumDistance", Number(e.target.value))
                                    }}
                                    type="number"
                                    value={v.MinimumDistance}
                                />
                            </td>

                            <td className="border p-1">

                                <InputContainer

                                    name="MaximumDistance"
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "MaximumDistance", Number(e.target.value))
                                    }}
                                    type="number"
                                    value={v.MaximumDistance}
                                />
                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    name="DistanceIncrement"
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "DistanceIncrement", Number(e.target.value))
                                    }}
                                    type="number"
                                    value={v.DistanceIncrement}
                                />
                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    name="DistanceIncrementCharge"
                                    onValueChange={(e: any) => {
                                        handleFormItemChange(idx, "DistanceIncrementCharge", Number(e.target.value))
                                    }}
                                    type="number"
                                    value={v.DistanceIncrementCharge}
                                />
                            </td>

                            <td className="border p-1 item-center">

                                <div className="flex items-center justify-center">
                                    <svg xmlns="http:www.w3.org/2000/svg" onClick={() => removeTaxonomy(idx)} width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>

                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button
                type="button"
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                onClick={(e) => {
                    e.preventDefault();
                    addTaxonomyRow();
                }}
            >
                + Add Vehicle charge Row
            </button>

        </>

    );
};

